import {configureStore} from '@reduxjs/toolkit';
import { promiseMiddleware } from '@teroneko/redux-saga-promise';
import createSagaMiddleware from 'redux-saga';

import rootReducer from 'store/root.reducer';
import rootSaga from 'store/root.saga';

export function configureAppStore(preloadedState: object) {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActionPaths: ['meta.promiseActions', 'meta.promiseResolution'],
      }
    }).concat([promiseMiddleware, sagaMiddleware]),
    preloadedState
  });
  sagaMiddleware.run(rootSaga);

  return store;
}